// Normaliza un valor ingresado por el usuario (que puede usar coma o punto
// como separador decimal, p.ej. "2,5" o "2.5") a un Number de JS. Se usa en
// todo formulario que capture superficie en hectáreas u otros decimales
// donde el teclado numérico móvil puede insertar una coma.
export function normalizarDecimal(valor) {
  if (valor === null || valor === undefined || valor === '') return null;

  const normalizado = String(valor).trim().replace(',', '.');

  const numero = Number(normalizado);

  return Number.isFinite(numero) ? numero : null;
}

// Valida que un valor de superficie (ha) ingresado como texto sea un
// decimal (coma o punto) mayor a 0. Reutilizado por los formularios de
// Aplicaciones y Fertilizantes.
export function esSuperficieValida(valor) {
  const numero = normalizarDecimal(valor);
  return numero !== null && numero > 0;
}
